/**
 * Domain-aware status badge.
 *
 * Wraps <Badge> with automatic color and label lookup for a given
 * status domain (session, simulator, queue, server, event, mode).
 */

import { Badge } from "./Badge";
import {
  SESSION_STATUS_COLORS,
  SESSION_STATUS_LABELS,
  SIMULATOR_STATUS_COLORS,
  SIMULATOR_STATUS_LABELS,
  QUEUE_STATUS_COLORS,
  QUEUE_STATUS_LABELS,
  SERVER_STATUS_COLORS,
  SERVER_STATUS_LABELS,
  EVENT_STATUS_COLORS,
  EVENT_STATUS_LABELS,
  MODE_COLORS,
  MODE_LABELS,
} from "./constants";

type StatusDomain = "session" | "simulator" | "queue" | "server" | "event" | "mode";

const COLOR_MAPS: Record<StatusDomain, Record<string, string>> = {
  session: SESSION_STATUS_COLORS,
  simulator: SIMULATOR_STATUS_COLORS,
  queue: QUEUE_STATUS_COLORS,
  server: SERVER_STATUS_COLORS,
  event: EVENT_STATUS_COLORS,
  mode: MODE_COLORS,
};

const LABEL_MAPS: Record<StatusDomain, Record<string, string>> = {
  session: SESSION_STATUS_LABELS,
  simulator: SIMULATOR_STATUS_LABELS,
  queue: QUEUE_STATUS_LABELS,
  server: SERVER_STATUS_LABELS,
  event: EVENT_STATUS_LABELS,
  mode: MODE_LABELS,
};

interface StatusBadgeProps {
  domain: StatusDomain;
  status: string;
  className?: string;
}

export function StatusBadge({ domain, status, className }: StatusBadgeProps) {
  const colorClass = COLOR_MAPS[domain][status] ?? "bg-gray-100 text-gray-800";
  const label = LABEL_MAPS[domain][status] ?? status;
  return <Badge className={className ?? colorClass}>{label}</Badge>;
}
